import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['item'] // optional, defaults to element
  static classes = ['hidden', 'visible', 'neutral', 'animation']
  // session storage name to show once per session
  static values = { name: String, disabled: Boolean, memoizeState: Boolean }

  connect () {
    super.connect()
    this.handleAddress()
  }

  // Browser address bar hash change handler
  handleAddress (event) {
    if (this.hasNameValue && location.hash.slice(1) === this.nameValue) {
      this.show()
      event.preventDefault()
    } else if (this.sessionState === 'visible') {
      this.hide()
    }
  }

  toggle () {
    this.items.forEach(item => {
      item.classList.toggle(this.hiddenClass)
      item.classList.toggle(this.visibleClass)
    })
  }

  applySessionState () {
    if (!this.memoizeStateValue && !this.sessionState) {
      this.neutral()
      return
    }

    this.sessionState === 'visible' ? this.show() : this.hide()
  }

  showMaybe () {
    if (this.sessionState === 'hidden') return

    this.show()
  }

  show ({ params: { saveState = false } = {} } = {}) {
    this.#show()
    if (saveState) this.sessionState = 'visible'
  }

  #show () {
    this.perform(() => {
      this.items.forEach(item => {
        item.classList.remove(this.hiddenClass)
        item.classList.add(this.visibleClass)
      })
    })
  }

  // TODO: rename to hideClickOutside
  clickOutside ({ target } = {}) {
    if (!this.element.contains(target)) {
      this.hide()
    }
  }

  hide ({ params: { saveState = false } = {} } = {}) {
    this.#hide()
    if (saveState) this.sessionState = 'hidden'
  }

  #hide () {
    this.perform(() => {
      this.items.forEach(item => {
        item.classList.remove(this.visibleClass)
        item.classList.add(this.hiddenClass)
      })
    })
    location.hash = ''
  }

  neutral () {
    this.perform(() => {
      this.hasNeutralClass &&
        this.items.forEach(item => {
          item.classList.remove(this.hiddenClass)
          item.classList.remove(this.visibleClass)
          item.classList.add(this.neutralClass)
        })
    })
    this.sessionState = null
  }

  perform (block) {
    if (!this.hasAnimationClass) { console.warn('no animation'); block(); return }

    this.items.forEach(item => item.classList.add(this.animationClass))
    setTimeout(() => {
      block()
      setTimeout(() => {
        this.items.forEach(item => item.classList.remove(this.animationClass))
      }, 500)
    }, 0)
  }

  get hiddenClass () {
    return this.hasHiddenClass ? this.classes.get('hidden') : 'hidden'
  }

  get visibleClass () {
    return this.hasVisibleClass ? this.classes.get('visible') : 'visible'
  }

  get items () {
    return this.hasItemTarget ? this.itemTargets : [this.element]
  }

  get sessionState () {
    return this.hasNameValue ? this.storage.getItem(this.nameValue) : undefined
  }

  set sessionState (value) {
    if (!this.hasNameValue) return

    value == null ? this.storage.removeItem(this.nameValue) : this.storage.setItem(this.nameValue, value)
  }

  get storage () {
    return window.sessionStorage
  }
}
